export default __webpack_public_path__ + "static/media/pantry1-afterI.007cde62.jpg";